import '~/map/map/boundary/boundaryZoomLevelDisclaimer/boundaryZoomLevelDisclaimerModal.component.autoload';
import { useCallback } from 'react';
import { checkIfModalIsAlreadyConfirmed } from '~/_shared/components/modal/confirmation/confirmationModal.helpers';
import { PermanentConfirmStrategy } from '~/_shared/components/modal/confirmation/useConfirmationModal';
import { useStorageService } from '~/_shared/utils/storageService';
import { HIDE_BOUNDARY_ZOOM_DISCLAIMER_SESSION_KEY } from '~/map/map/boundary/boundaryView/mapBoundaryPolygons/useBoundaryZoomDisclaimer';
import type { ModalTypeProps } from '~/modal/modalRegistry.type';
import { useModal } from '~/modal/useModal.hook';

export const useBoundaryZoomDisclaimerModal = () => {
  const { openModal, closeModal } = useModal('BoundaryZoomLevelDisclaimer');
  const storageService = useStorageService();

  const handleOpenModal = useCallback(({ items }: ModalTypeProps<'BoundaryZoomLevelDisclaimer'>) => {
    const isModalConfirmed = checkIfModalIsAlreadyConfirmed({
      id: HIDE_BOUNDARY_ZOOM_DISCLAIMER_SESSION_KEY,
      strategy: PermanentConfirmStrategy.Session,
    }, storageService);

    if (isModalConfirmed || items.length === 0) {
      return;
    }

    openModal({ items });
  }, [openModal, storageService]);

  return {
    openModal: handleOpenModal,
    closeModal,
  };
};
